/**
 * Cómo se llega directo a las solicitudes de ingreso de una tanda: el panel de
 * administración con `?abrir=solicitudes`. Lo usan la campana y el dashboard;
 * admin-tanda lo lee y abre el diálogo bajando a la lista.
 *
 * Con `&solicitud=<idu_request>` (aviso nuevo, `cod_route`
 * `tanda/<id>/solicitudes/<idu_request>`) se abre directo la decisión de esa
 * solicitud ("Fulano quiere entrar").
 */
export const ABRIR_SOLICITUDES = 'solicitudes';

/** Query param con la solicitud a abrir. */
export const PARAM_SOLICITUD = 'solicitud';

/** Query params para `routerLink` / `router.navigate`. */
export const abrirSolicitudes = (iduRequest?: string | null): Record<string, string> =>
    iduRequest ? { abrir: ABRIR_SOLICITUDES, [PARAM_SOLICITUD]: iduRequest } : { abrir: ABRIR_SOLICITUDES };
